/* eslint-disable react-hooks/exhaustive-deps */
import { useForm } from "@corets/use-form"
import { useAsync } from "@corets/use-async"
import { ChangeEvent, KeyboardEvent, useEffect } from "react"
import { useHistory } from "react-router"
import { WPlus } from "../../../../../assets/images"
import { links } from "../../../../../config/links"
import { SearchCommuneFormType, createSearchCommuneForm } from "./createSearchCommuneForm"
import { useApiClient } from "../../../../oneportal/hooks/useApiClient"
import { getLookupProvince, getLookupDistrict } from "../../../../oneportal/services/api/administrative"
import { createMuiFormBinder } from "../../../../oneportal/helpers/createMuiFormBinder"
import { Select } from "../../../../oneportal/components/Select"

export type SearchCommuneFormProps = {
  onSubmit: (data: SearchCommuneFormType) => void
  defaultValue: SearchCommuneFormType
}
export const SearchCommuneForm = (props: SearchCommuneFormProps) => {
  const { onSubmit, defaultValue } = props
  const history = useHistory()
  const api = useApiClient()

  const [form] = useForm(createSearchCommuneForm(defaultValue), [defaultValue])
  const bind = createMuiFormBinder(form)
  const provinceOptions = useAsync(() => getLookupProvince(api), [])
  const districtList = useAsync(
    async () => form.getAt("provinceId") && (await getLookupDistrict(api, form.getAt("provinceId"))),
    [form.getAt("provinceId")]
  )

  const handleSubmit = async () => {
    const data = await form.get()
    onSubmit(data)
  }

  useEffect(() => {
    if (form.getAt("provinceId")) {
      handleSubmit()
    }
  }, [form.getAt("provinceId")])

  useEffect(() => {
    if (form.getAt("districtId")) {
      handleSubmit()
    }
  }, [form.getAt("districtId")])

  const handleChangeFormValue = (event: ChangeEvent<HTMLInputElement>, field: string) => {
    const value = event.target.value
    form.setAt(field, value)
    if (!value) {
      handleSubmit()
    }
  }

  const handleKeyEnter = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault()
      handleSubmit()
    }
  }

  return (
    <form>
      <div className="form-row flex-wrap">
        <div className="form-group mb-0 col-lg-4">
          <input
            value={form.getAt("keyword") || ""}
            onChange={(event) => handleChangeFormValue(event, "keyword")}
            className="form-control"
            placeholder="Tìm theo tên"
            onKeyDown={handleKeyEnter}
          />
        </div>
        <div className="form-group mb-0 col-lg-2">
          <Select
            options={provinceOptions.getResult()?.content}
            bind={bind}
            field={"provinceId"}
            labelDefaultOption="Chọn địa phương"
          />
        </div>
        <div className="form-group mb-0 col-lg-2">
          <Select
            options={districtList.getResult()?.content}
            bind={bind}
            field={"districtId"}
            labelDefaultOption="Chọn quận huyện"
          />
        </div>
        <div className="form__save-ct">
          <div className="form__save border-top-0 pt-0 mt-0 justify-content-start">
            <button className="btn btn-ct btn-primary-ct" type="button" onClick={handleSubmit}>
              Tìm kiếm
            </button>
            <button
              className="btn  btn-ct  btn-add btn-danger-ct  d-flex align-items-center"
              type="button"
              onClick={() => history.push(links.category.createCommune())}
            >
              Thêm phường xã
              <img src={WPlus} alt="" />
            </button>
          </div>
        </div>
      </div>
    </form>
  )
}
